import { phoneReg, emailReg } from "utils";
import {host} from "src/config";
import { formatByJson, typeOf } from "utils";
export const applyMixins = {
  props: {
    isCs: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    commonProps: {
      type: Object,
      default() {
        return {}
      }
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    linkDisabled: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: null,
    },
    reportLuaCode: {
      type: String,
      default: ''
    },
    formInfo: {
      type: Object,
      default: null
    },
    moduleData: {
      type: Object,
      default: null
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    },
    env: {
      type: String,
      default: 'local'
    },
    isOiq: {
      type: Boolean,
      default: false
    },
    notShare: {
      type: Boolean,
      default: true
    },
    hasUser: {
      type: Boolean,
      default: false
    },
    bu: {
      type: String,
      default: ''
    },
    orderDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    csInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    invoiceData: {
      type: Object,
      default() {
        return {}
      }
    },
    applyInfoData: {
      type: Object,
      default() {
        return {}
      }
    },
    enumConfig: {
      type: Object,
      default: null
    },
    invoiceFileList: {
      type: Array,
      default() {
        return []
      }
    },
    emailRequired: {
      type: Boolean,
      default: true
    },
    isCreate: {
      type: Boolean,
      default: true
    },
    isSave: {
      type: Boolean,
      default: false
    },
    buName: {
      type: String,
      default: ''
    },
    businessInfo: {
      type: Object,
      default: null
    },
    sampleCategoryByCode: {
      type: Object,
      default: null
    },
    formConfig: {
      type: Array,
      default() {
        return []
      }
    },
    step1Form: {
      type: Object,
      default() {
        return {}
      }
    },
    isCountryChange: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const validateRequired = (rule, value, callback) => {
      if (this.isSave && (!value && value !== 0 || (typeOf(value) === 'array' && !value.length))) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validateRequiredEn = (rule, value, callback) => {
      if (this.isSave && (this.reportLuaCode && this.reportLuaCode !== 'ZN') && !value) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validateEn = (rule, value, callback) => {
      const reg = /^[^\u4e00-\u9fa5]+$/
      if (value && !reg.test(value)) {
        return callback(new Error('请输入英文字符'));
      } else {
        return callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value && !phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        return callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱必填'))
      } else if (!emailReg.test(value)) {
        return callback(new Error('请输入正确的邮箱'))
      } else {
        return callback()
      }
    }
    const required = { trigger: 'change', validator: validateRequired }
    const requiredEn = { trigger: 'change', validator: validateRequiredEn }
    const validatorEn = { validator: validateEn }
    const phoneRule = { validator: validatePhone }
    const emailRule = { validator: validateEmail }
    return {
      required,
      requiredEn,
      validatorEn,
      phoneRule,
      emailRule,
      host: host(this.commonProps.env),
      formatByJson,
      csMailReg: /^[a-zA-Z0-9_.-]+@sgs.com$/,
      hasCs: true,
      orderNo: '',
      isAgain: '',
      route: null,
      currentKey: {},
      currentData: {},
      addressDialog: false,
      addressListShow: false,
      isAdd: false
    }
  },
  watch: {
    $route: {
      handler(val) {
        const query = val.query
        this.orderNo = query.orderNo
        this.isAgain = !!query.isAgain
      },
      immediate: true
    },
  },
  created() {
  },
  methods: {
    toggleAddress() {
      this.addressListShow = !this.addressListShow
      this.isAdd = !this.addressListShow
      this.$nextTick(() => {
        this.addressDialog = true
      })
    },
    getTfsRules(data, isRequired) {
      const rules = []
      if (data.isMust) {
        if (isRequired) {
          rules.push({ required: true, message: '必填项' })
        } else {
          rules.push(this.required)
        }
      }
      if (data.regexRule) {
        const validator = (rule, value, callback) => {
          if (value && !new RegExp(data.regexRule).test(value)) {
            return callback(new Error(data.showAttr.ruleErrMsg || '格式错误'));
          } else {
            return callback()
          }
        }
        rules.push({ validator, trigger: ['change', 'blur'] })
      }
      if (data.showAttr && data.showAttr.fileType) {
        const fileTypeArr = data.showAttr.fileType.split(',')
        const ladingBillType = this.step1Form.destinationObj.ladingBillType
        const validator = (rule, value, callback) => {
          if ((this.isSave || isRequired) && (!value && value !== 0 || (typeOf(value) === 'array' && !value.length))) {
            const msg = data.fillType === 'button' ? '请' + data.showValue : '必填项'
            if(fileTypeArr.includes(ladingBillType)) {
              if (!this.step1Form.destinationObj[ladingBillType].length) {
                return callback(new Error(msg));
              } else {
                return callback()
              }
            } else {
              if (!this.step1Form.destinationObj[data.showAttr.fileType].length) {
                return callback(new Error(msg));
              } else {
                return callback()
              }
            }
          } else {
            return callback()
          }
        }
        rules.push({ validator, trigger: ['change', 'blur'] })

      }
      return rules
    },
    getFormConfigByCode(list) {
      const obj = {}
      list.forEach(v => {
        if (!v.showAttr) v.showAttr = {}
        obj[v.attrCode] = v
      })
      return obj
    },
    openAddress(currentKey, index) {
      this.isAdd = false
      this.currentKey = currentKey
      this.currentIndex = -1
      if (typeof index === 'number') {
        this.currentData = this[currentKey][index].userAddressDTO
        this.currentIndex = index
      }
      this.addressDialog = true
      this.addressListShow = this.hasUser && (!this.isCs || this.currentData.addressId || !this.currentData.companyAddress)
    },
    updateAddressData(data) {
      let addressDetail = {}
      if (data.provinceData) {
        addressDetail = Object.assign(data, {
          province: data.provinceData[0],
          city: data.provinceData[1],
          town: data.provinceData[2],
        })
      } else {
        addressDetail = data
      }
      if (this.currentIndex === -1) {
        this[this.currentKey].push({
          addressId: addressDetail.addressId,
          userAddressDTO: addressDetail
        })
        return
      }
      this[this.currentKey][this.currentIndex] = {
        addressId: addressDetail.addressId,
        userAddressDTO: addressDetail
      }
    },
    delAddress(addressId) {
      this.$emit('delAddress', addressId)
    },
  }
}